import {
  CREATE_CASE_FROM_ALERT_SUCCESS,
  CREATE_CASE_FROM_ALERT_FAIL,
  CREATE_CASE_FROM_ALERT,
  CLOSE_CASE_FROM_ALERT_INFO_MODAL,
  SELECT_ALERTS_FOR_ACTIONS,
  RESET_CONVERT_ALERTS_TO_CASE
} from '../../actions/cm/convertAlertsToCase';

export const initialState = {
  isLoading: false,
  isChangeAlertToCaseFailed: false,
  showInfoModal: false,
  selectedIds: [],
  errorMessage: '',
  caseId: null,
  // FIN-12949/FIN-13021 — partial-create outcome lists.
  skippedAlreadyCased: [],
  skippedUnknown: []
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CREATE_CASE_FROM_ALERT:
      return {
        ...state,
        isChangeAlertToCaseFailed: false,
        showInfoModal: false,
        isLoading: true,
        errorMessage: '',
        // cleared per attempt, or the previous create's skip counts would be re-reported
        skippedAlreadyCased: [],
        skippedUnknown: []
      };
    case CREATE_CASE_FROM_ALERT_SUCCESS:
      return {
        ...state,
        showInfoModal: true,
        isLoading: false,
        caseId: payload.caseId,
        skippedAlreadyCased: payload.skippedAlreadyCased || [],
        skippedUnknown: payload.skippedUnknown || []
      };
    case CREATE_CASE_FROM_ALERT_FAIL:
      return {
        ...state,
        isChangeAlertToCaseFailed: true,
        isLoading: false,
        errorMessage: payload
      };
    case CLOSE_CASE_FROM_ALERT_INFO_MODAL:
      return {
        ...state,
        showInfoModal: false,
        isChangeAlertToCaseFailed: false,
        isLoading: false
      };
    case SELECT_ALERTS_FOR_ACTIONS:
      return { ...state, selectedIds: payload };
    case RESET_CONVERT_ALERTS_TO_CASE:
      return {
        ...state,
        isChangeAlertToCaseFailed: false,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
}
